import React from "react";

import Product from "../Product";

import {Container, Wrapper} from "./styles";

const Layout = (props: any) => {
    return (
        <Container>
            <Wrapper>
                <Product match={props.match}/>
            </Wrapper>
        </Container>
    );
};

export default Layout;
